import { render, staticRenderFns } from "./my-order-payment.vue?vue&type=template&id=b3f8b47c&"
import script from "./my-order-payment.vue?vue&type=script&lang=js&"
export * from "./my-order-payment.vue?vue&type=script&lang=js&"
import style0 from "./my-order-payment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports